import React from 'react';
import { object } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import ContactTrigger from '../../../shared/ContactTrigger';
import { reportContactSellerClick } from '../../../../utils/contactSeller';
import PromoteMTTooltip from './PromoteMTTooltip';

import './style.scss';

const ContactMe = (props, { biEvents, general }) => {

    const reportContactMeClick = () => reportContactSellerClick({
        biEvents,
        general,
        mixpanelSourceComponent: 'Gig page seller card',
        bqSourceName: 'about_the_seller',
        metricKey: 'contact_me.click'
    });

    return (
        <PromoteMTTooltip>
            <ContactTrigger onClick={reportContactMeClick} className="btn-contact-me">
                <I18n k={'gig_page_perseus.seller_card.contact_me'}/>
            </ContactTrigger>
        </PromoteMTTooltip>
    );
};

ContactMe.contextTypes = {
    biEvents: object,
    general: object
};

export default ContactMe;
